import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-tooltip__text" }


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppTooltip',
  props: {
    position: {},
    showArrow: { type: Boolean },
    show: { type: Boolean, default: false }
  },
  setup(__props: any) {



/**
 * A basic tooltip component.
 *
 * Besides the component props, the tooltip can be further customized by overwriting the
 * `--tooltip-width` and `--tooltip-distance` CSS variables.
 *
 * `--tooltip-width` sets the width of the tooltip.
 * `--tooltip-distance` sets the distance between the tooltip and its parent.
 *
 * @param position - Whether to display the tooltip above or below it's parent.
 * @param showArrow - Whether or not to display the arrow pointing to the parent.
 * @param show - Whether to show the tooltip or not.
 */

const props = __props

function classes(): Record<string, boolean> {
  return {
    'app-tooltip--top': props.position === 'top',
    'app-tooltip--bottom': props.position === 'bottom',
    'app-tooltip--arrow': props.showArrow,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['app-tooltip', _ctx.$attrs.class, classes()])
      }, [
        _createElementVNode("p", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2), [
        [_vShow, __props.show ?? false]
      ])
    ]),
    _: 3
  }))
}
}

})